import { defineMessages } from 'react-intl';

export const messages: {
	label: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	label: {
		id: 'navigation.global-side-navigation.for-you.label',
		description:
			'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
		defaultMessage: 'For you',
	},
});
